export default {
  namespaced: true,
  state () {
    return {
      blobImages: []
    }
  },
  getters: {
    blobImages (state) {
      return state.blobImages
    },
    async base64Images (state) {
      function blobToBase64 (blob) {
        return new Promise((resolve) => {
          const reader = new FileReader()
          reader.onloadend = () => resolve(reader.result)
          reader.readAsDataURL(blob)
        })
      }
      const result = []

      for (const image of state.blobImages) {
        const base64Image = await blobToBase64(image)
        result.push(base64Image)
      }

      return result
    }
  }
}
